import { updateNotificationSettings } from '@front-app/services/GroupsApi/GroupsAdmin';
import { AdminSettings } from '@front-app/services/GroupsApi/GroupModel';
import { GroupsStore } from '@front-app/store/modules/groups';

export interface GroupSettingsStore {
	update(notificationSettings: AdminSettings, groupId: string): Promise<void>;
}

export const getGroupSettingsStore = (groupsStore: GroupsStore): GroupSettingsStore => {
	const update = async (notificationSettings: AdminSettings, groupId: string) => {
		const updatedNotificationSettings = await updateNotificationSettings(notificationSettings, groupId);
		const groupToUpdate = groupsStore.groupById(groupId);
		if (groupToUpdate) {
			groupToUpdate.adminSettings = updatedNotificationSettings;
			groupsStore.updateLocalGroup(groupId, groupToUpdate);
		}
	};
	return {
		update,
	};
};
